import { FlightEventHandler, registerEventHandlerClass } from "./flight";
import ADSBMarkerSet from "../components/adsbMarkerSet"

export default class RegionADSB extends FlightEventHandler {
	constructor(flight) {
		super(flight)

		this.markerSet = new ADSBMarkerSet("ADSB", {maxLastSeen:10000}, flight.overlay)
	}

	handleKeyframe(keyframe) {
		this.clearMarkers()
		const now = keyframe.end

		for (const at of keyframe.airTraffic) {
			this.markerSet.update(at, now)
		}
	}

	handleFlightStep(msg, cleanOld = true) {
		if(cleanOld) this.cleanOldMarkers(msg.timestamp)
		if (msg.type === "AIR_TRAFFIC") {
			this.markerSet.update(msg.data, msg.timestamp)
		}
	}

	clearMarkers() {
		this.markerSet.clear()
	}

	cleanup() {
		super.cleanup()
		this.markerSet.cleanup()
	}

	cleanOldMarkers(now) {
		this.markerSet.clean(now)
	}
}

registerEventHandlerClass(RegionADSB)